module.exports = __webpack_public_path__ + "img/logo-header.781abc20.png";